exports.domain = "https://asahisushiolympia.com/"
exports.googleMapAPI = "AIzaSyCNwQio9tz4umW7OlBP5UwZHfr0bY4Fh9I"

